import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/material/styles";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import { Link } from "@mui/material";
import DialogButton from "./DialogButton";
import DialogActions from "@mui/material/DialogActions";
import { Grid } from "@mui/material";

export default function Instructions(props) {
  // Props passed in to render Dialog box
  const { modelState, createGame, nextRound, setIsInstructionsOpen, open } = props;

  const CustomDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiPaper-root": {
      backgroundColor: "#20202a",
      borderRadius: "15px",
      // Maybe not?
      border: "1px solid #4D4D75",
    },
    "& .MuiButton-root": {
      backgroundColor: "#c9333b",
      "&:hover": {
        backgroundColor: "#AB151D",
      },
    },
  }));

  // Start game on PLAY NOW button pressed
  const handleClick = (userId) => {
    createGame(userId).then(() => {
      setIsInstructionsOpen(false);
      nextRound();
    });
  };

  return (
    <div>
      <CustomDialog open={open} fullWidth={true} maxWidth={"md"}>
        <DialogTitle sx={{textShadow: "0 0 1px #c9333b, 0 0 5px #c9333b",
          letterSpacing: "2px"}}>
          {`WELCOME TO GUESS FM`}
        </DialogTitle>
        {/* Add margin around content */}
        <DialogContent sx={{textAlign: "center" }}>
          {/* <Typography sx={{marginBottom: 2}}>{"HOW TO PLAY: "}</Typography> */}
          <Grid sx={{ flexGrow: 1 }} container spacing={2} justifyContent={"flex-end"}>
            <Grid item xs={3}>
              <Typography sx={{textAlign: "right" }}>
                {"🙁"}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </Typography>
            </Grid>
            <Grid item xs={9} sx={{textAlign: "left" }}>
              <Typography>
                {"Unfortunately, Radio Garden has requested this student project to be taken down."}
              </Typography>
            </Grid>
            <Grid item xs={3} sx={{textAlign: "right" }}>
              <Typography>
                {"🤓"}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </Typography>
            </Grid>
            <Grid item xs={9} sx={{textAlign: "left" }}>
              <Typography>
                {"Guess FM was built by "}<Link href="https://github.com/andrewlpmcneill" >{"Andrew McNeill"}</Link>
                {", "}<Link href="https://github.com/ryjcm1">{"Jimmy Chuk"}</Link>{", and "}
                <Link href="https://github.com/seamusmcgill">{"Seamus McGill"}</Link>{" in Spring 2022 as part of Lighthouse Labs' web development bootcamp."}
              </Typography>
            </Grid>
            <Grid item xs={3} sx={{textAlign: "right" }}>
              <Typography>
                {"❤️"}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </Typography>
            </Grid>
            <Grid item xs={9} sx={{textAlign: "left" }}>
              <Typography>
                {"Thank you for enjoying GuessFM."}
              </Typography>
            </Grid>
            <Grid item xs={3} sx={{textAlign: "right" }}>
              <Typography>
                {"📁"}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </Typography>
            </Grid>
            <Grid item xs={9} sx={{textAlign: "left" }}>
              <Typography>
                {"Press the link below to visit this project's Github page."}
              </Typography>
            </Grid>
            <Grid item xs={3} sx={{textAlign: "right" }}>
              <Typography>
                {/* {"5️⃣"}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; */}
              </Typography>
            </Grid>
            <Grid item xs={9} sx={{textAlign: "left" }}>
              <Typography>
                {/* {"There are 3 rounds in a game."} */}
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            m: "auto",
            paddingBottom: 2,
            justifyContent: "space-between",
          }}
        >
          <DialogButton onClick={() => window.location.href = 'https://github.com/andrewlpmcneill/guess-fm'/*handleClick(modelState.userId)*/}>
            {"Visit us on Github"}
          </DialogButton>
        </DialogActions>
      </CustomDialog>
    </div>
  );
}
